import ShopaholicCouponAdd from '../../../js/shopaholic-coupon/shopaholic-coupon-add';
import ShopaholicCouponRemove from '../../../js/shopaholic-coupon/shopaholic-coupon-remove';
import ShopaholicCartShippingType from '../../../js/shopaholic-cart/shopaholic-cart-shipping-type';
import ShopaholicOrder from '../../../js/shopaholic-cart/shopaholic-order';
import ShopaholicCartPaymentMethod from '../../../js/shopaholic-cart/shopaholic-cart-payment-method';
import oc from 'octobercms';

export default new class Cart {
  constructor() {
    this.obShopaholicCartShippingType = new ShopaholicCartShippingType();
    this.obShopaholicCartPaymentMethod = new ShopaholicCartPaymentMethod();
    this.obShopaholicOrder = new ShopaholicOrder();
    this.obShopaholicCouponAdd = new ShopaholicCouponAdd();
    this.obShopaholicCouponRemove = new ShopaholicCouponRemove();

    this.tooltipClass = 'cart__coupon-tooltip';
    this.visibleTooltipClass = 'cart__coupon-tooltip_visible';
    this.sButtonClass = 'cart__coupon-btn';
    this.buttonDisabledClass = 'button_disabled';
    this.couponWrapperClass = 'cart__coupon-input';

    this.addButtonClass = '_shopaholic-coupon-add';
    this.removeButtonClass = '_shopaholic-coupon-remove';
    this.filledClass = 'input__field_disabled';
    this.paymentInput = 'cart__payment-field';


    this.init();

    this.initShippingType();
    this.initPaymentMethod();
    this.initCreateOrder();

    this.initAddCoupon();
    this.initRemoveCoupon();
    this.initClickHandler();
    this.paymentHandler();

    this.shippingFunction();
  }

  init() {
    const couponField = document.querySelector(`.${this.couponWrapperClass} input`);
    const couponBtn = document.querySelector(`.${this.sButtonClass}`);

    couponField.addEventListener('keypress', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
        couponBtn.click();
      }
    });

    couponField.addEventListener('keyup', ({ currentTarget }) => {
      const couponBtnState = currentTarget.value.length;

      couponBtn.disabled = !couponBtnState;
      if (couponBtnState) {
        couponBtn.classList.remove(this.buttonDisabledClass);
      } else {
        couponBtn.classList.add(this.buttonDisabledClass);
      }
    });
  }

  initShippingType() {
    this.obShopaholicCartShippingType.init();
  }

  initPaymentMethod() {
    this.obShopaholicCartPaymentMethod.init();
  }

  initCreateOrder() {
    document.addEventListener('bouncerFormValid', () => {
      const response = this.obShopaholicOrder.create();

      //ym(71180419,'reachGoal','cartSubmit');
    });
  }

  initAddCoupon() {
    this.obShopaholicCouponAdd.setAjaxRequestCallback((obRequestData, obInput, obButton) => {
      obRequestData.complete = (data, textStatus, jqXHR) => { // eslint-disable-line no-param-reassign
        console.log(data, textStatus, jqXHR);
        this.obShopaholicCouponAdd.completeCallback({data, textStatus, jqXHR}, obInput, obButton);
        if (data.status !== false) {
          obButton.classList.remove(this.addButtonClass);
          obButton.classList.add(this.removeButtonClass);
          obInput.classList.add(this.filledClass);
          obButton.innerHTML = 'Отменить купон'; // eslint-disable-line no-param-reassign
        } else {
          this.errorHandler(data.message);
          obInput.focus();
        }
      };
      return obRequestData;
    });
    this.obShopaholicCouponAdd.init();
  }

  initClickHandler() {
    const button = document.querySelector(`.${this.sButtonClass}`);
    button.addEventListener('click', () => {
      const errorTooltip = document.querySelector(`.${this.visibleTooltipClass}`);

      if (!errorTooltip) return;

      errorTooltip.classList.remove(this.visibleTooltipClass);
    });
  }

  paymentHandler() {
    const inputs = document.querySelectorAll(`.${this.paymentInput}`);
    inputs.forEach((input, index) => {
      if (input.hasAttribute('checked')) {
        this.checked = index;
      }
    });

    if (this.checked === 0) {
      inputs[1].checked = true;
      inputs[0].click();
    } else {
      inputs[0].checked = true;
      inputs[this.checked].click();
    }
  }

  errorHandler(message) {
    clearTimeout(this.timer);
    const tooltip = document.querySelector(`.${this.tooltipClass}`);
    tooltip.classList.add(this.visibleTooltipClass);
    tooltip.innerHTML = message;

    this.timer = setTimeout(() => {
      tooltip.classList.remove(this.visibleTooltipClass);
    }, 2000);
  }

  initRemoveCoupon() {
    this.obShopaholicCouponRemove.setAjaxRequestCallback((obRequestData, obInput, obButton) => {
      obRequestData.complete = (data, textStatus, jqXHR) => { // eslint-disable-line no-param-reassign
        console.log(data, textStatus, jqXHR);
        if (data.status !== false) {
          this.obShopaholicCouponRemove.completeCallback({data, textStatus, jqXHR}, obInput, obButton);
          obButton.classList.add(this.addButtonClass);
          obButton.classList.remove(this.removeButtonClass);
          obInput.classList.remove(this.filledClass);
          obInput.focus();
          obButton.innerHTML = 'Применить купон'; // eslint-disable-line no-param-reassign
        } else {
          this.errorHandler(data.message);
        }
      };
      return obRequestData;
    });
    this.obShopaholicCouponRemove.init();
  }

  shippingFunction() {
    const sessionKey = document.querySelector('input[name="_session_key"]');
    sessionKey.classList.add('_shopaholic-order-field');

    const token = document.querySelector('input[name="_token"]');
    token.classList.add('_shopaholic-order-field');

    document.querySelector('.shipping-type-select').addEventListener('change', (e) => {
      const text = document.querySelector('#ShipValText');

      if (e.target.value === '1') {
        text.innerHTML = 'самовывозом';
      } else {
        text.innerHTML = 'доставкой';
      }

      setTimeout(this.paymentHandler(), 1000);
    });
   }

  handleFile() {
    const fileInput = document.querySelector('._file-input');
    const sessionKeyInput = document.querySelector('[name="_session_key"]');

    const sessionKey = sessionKeyInput.value;

    fileInput.addEventListener('change', () => {
      var fReader = new FileReader();
      const type = fileInput.files[0].type;

      fReader.readAsDataURL(fileInput.files[0]);

      fReader.onloadend = function(event){
        oc.ajax('Checkout::onLoadFile', {
          data: { file: event.target.result, type: type, sessionKey: sessionKey }
        });
      }
    });
  }
}();

